export default __webpack_public_path__ + "static/media/grafema_gim-tonico_13.4e048f4c.mp4";